module.exports = __webpack_public_path__ + "static/media/ball-blur-line.75fac04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/ball-blur-line.png
// module id = 3597
// module chunks = 0